import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './redux/reducers/index';
import apiMiddleware from './redux/middleware/apiMiddleware';
// import { apiMdl } from './redux/middleware/apiMiddleware';
import { unitMdl } from './redux/middleware/unitMiddleware';
import { userMdl } from './redux/middleware/userMiddleware';
import { eulaMdl } from './redux/middleware/eulaMiddleware';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { messagesMdl } from './redux/middleware/messagesMiddleware';
import { authMdl } from './redux/middleware/authMiddleware';
import { currentUserMdl } from './redux/middleware/currentUserMiddleware';
import { userUnitMdl } from './redux/middleware/userUnitMiddleware';
import { alarmDevicesMdl } from './redux/middleware/alarmDeviceMiddleware';
import { alertDevicesMdl } from './redux/middleware/alertDeviceMiddleware';
import { devicesMdl } from './redux/middleware/deviceMiddleware';
import { userStaffPreferencesMdl } from './redux/middleware/userStaffPreferencesMiddleware';
import { userCheckinProfileMdl } from './redux/middleware/userCheckinProfileMiddleware';
import { unitCheckinProfileMdl } from './redux/middleware/unitCheckinProfileMiddleware';
import { clearStoreMdl } from './redux/middleware/clearStoreMiddleware';
import { systemMdl } from './redux/middleware/systemMiddleware';
import { reportsMdl } from './redux/middleware/reportsMiddleware';
import { supportMdl } from './redux/middleware/supportMiddleware';
import { assignDevicesMdl } from './redux/middleware/assignDevicesMiddleware';
import { docAndImagesMdl } from './redux/middleware/docAndImagesMiddleware';
import { loginRecoveryMdl } from './redux/middleware/loginRecoveryMiddleware';

// This is the config for the local storage persist reducer. The "blacklist" section is an array that determines which content from the redux store are not stored locally
const persistConfig = {
  key: 'SaraRoot',
  storage,
  blacklist: ['form', 'ui', 'temp'],
};

// Initialize the local storage persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// This is for redux dev tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// This combines the different middlewares into a single array. By exporting the middlewares as individual arrays and then spreading them here new middleware can be added in each file without having to update this file
export const middleware = [
  apiMiddleware,
  ...userMdl,
  ...unitMdl,
  ...eulaMdl,
  ...messagesMdl,
  ...authMdl,
  ...currentUserMdl,
  ...userUnitMdl,
  ...alertDevicesMdl,
  ...alarmDevicesMdl,
  ...userStaffPreferencesMdl,
  ...userCheckinProfileMdl,
  ...unitCheckinProfileMdl,
  ...devicesMdl,
  ...clearStoreMdl,
  ...systemMdl,
  ...reportsMdl,
  ...supportMdl,
  ...assignDevicesMdl,
  ...docAndImagesMdl,
  ...loginRecoveryMdl,
  // ...apiMdl,
];

// Create the actual store and apply the middleware
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

// This is exported so that the persist store can be cleared when logging out
export const persistor = persistStore(store);

export default store;
